module.exports = __webpack_public_path__ + "img/058-bathtub.117623dc.svg";